<script>
  import resources from './resources'

  export default {
    name: 'gadget-summary-agenda',
    mixins: [resources]
  }
</script>

<template lang="pug">
  div
    section.gadget-agenda-resumida.white-bg.wrapper.half-width.gadget(v-for="rule in rules", :key="rule.id")
      .gadget-title
        | Agenda Resumida Por Regra (ID: {{ rule.id }})
      .actions
        span.icon 
        ul
          li.exclude Remover
          li.half-width Lado a Lado
          li.full-width Tela Inteira
      div
        .col-xs-12.col-md-7
          label.light-red Agenda
          h3.medium-gray {{ rule.agenda.name }}
        .col-xs-12.col-sm-5
          label.light-red Validade
          h3.medium-gray {{ rule.valid }}
      .clearfix
      div(style='margin-top:15px')
        .col-xs-12.col-md-7
          label.light-red Especialidade Médica
          h4.medium-gray {{ rule.agenda.specialities }}
        .col-xs-12.col-sm-5
          label.light-red Dias da Semana
          h4.medium-gray {{ rule.days }}
      .clearfix
      div
        .col-xs-12.col-md-7
          label.light-red Convênios
          h3.medium-gray {{ rule.agenda.covenants }}
        .col-xs-12.col-sm-5
          label.light-red
            | Intervalo
            small (minutos)
          h3.medium-gray {{ rule.interval }}
      .clearfix
      div(style='margin-top:15px')
        .col-xs-12
          label.light-red Situação da Agenda
          .percentage-graph
            // Base
            .base
              .text {{ rule.completed }}% Preenchida
            // Cor
            .color(:style="'width: '+ rule.completed + '%'")
              .text
                | {{ rule.completed }}% Preenchida
</template>



// WEBPACK FOOTER //
// src/app/team/dashboard/gadget/components/summary-agenda/summary-agenda.vue